import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Dashboard as DashboardModel } from '@src/main/modules/common/dashboard/domain/Dashboard';
import { useDashboardContext } from '@src/main/ui/providers/dashboard/DashboardContextProvider';
import { useUserContext } from '@src/main/ui/providers/user/UserContextProvider';

import DashboardFooter from '@src/main/ui/components/Dashboard/DashboardFooter/DashboardFooter';
import DashboardHeader from '@src/main/ui/components/Dashboard/DashboardHeader/DashboardHeader';
import { LookerStudio } from '@src/main/ui/components/Dashboard/LookerStudio/LookerStudio';
import NonEmbeddable from '@src/main/ui/components/Dashboard/NonEmbeddable/NonEmbeddable';
import { PowerApp } from '@src/main/ui/components/Dashboard/PowerApp/PowerApp';
import { Report } from '@src/main/ui/components/Dashboard/report/Report';
import { NotFoundPage } from '@src/main/ui/components/common/NotFoundPage/NotFoundPage';
import styles from './Dashboard.module.scss';

const Dashboard: FC = () => {
  const { dashboardId } = useParams();
  const { dashboards } = useDashboardContext();
  const [dashboardFound, setDashboardFound] = useState<DashboardModel | undefined>();
  const { addRecentlyOpened } = useUserContext();

  useEffect(() => {
    if (dashboards) {
      const dashboardSearch = dashboards.find((dashboard) => dashboard.id === dashboardId);
      if (dashboardSearch) {
        setDashboardFound(dashboardSearch);
        addRecentlyOpened(dashboardSearch);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboards]);

  return (
    <>
      <div className={styles.container}>
        <DashboardHeader dashboard={dashboardFound} />

        {dashboardFound?.artifactType === 'PowerBIReport' && (
          <div className={styles.container}>
            <Report id={dashboardFound.artifactId} />
          </div>
        )}

        {dashboardFound?.artifactType === 'LookerStudio' && (
          <LookerStudio id={dashboardFound.artifactId} />
        )}

        {dashboardFound?.artifactType === 'PowerApp' && <PowerApp id={dashboardFound.artifactId} />}

        {dashboardFound?.artifactType === 'App' && (
          <>
            <NonEmbeddable
              url={`https://app.powerbi.com/groups/me/apps/${dashboardFound.artifactId}`}
            />
          </>
        )}

        {dashboardFound?.artifactType === 'PaginatedReport' && (
          <NonEmbeddable
            // eslint-disable-next-line max-len
            url={`https://app.powerbi.com/groups/${dashboardFound.workspaceId}/rdlreports/${dashboardFound.artifactId}`}
          />
        )}

        {dashboardFound?.artifactType === 'Dashboard' && (
          <NonEmbeddable
            // eslint-disable-next-line max-len
            url={`https://app.powerbi.com/groups/${dashboardFound.workspaceId}/dashboards/${dashboardFound.artifactId}`}
          />
        )}
        {dashboards && !dashboardFound && <NotFoundPage />}
      </div>

      <DashboardFooter dashboard={dashboardFound} />
    </>
  );
};

export default Dashboard;
